import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { clientToServerFiltering } from "../../../components/table/utils";
import { useDates } from "../../../dates/DatesContext";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";
type Params = {
  filters?: ColumnFiltersState;
  search?: string;
};

export const useGetV4SearchQueryPerformanceByDate = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, group, preStart, preEnd } = useDates();
  return (params: Params) => {
    const search = params.search ? params.search.split(",") : [];
    const filters = params.filters;
    return queryOptions({
      queryKey: [
        {
          entity: "V4SearchQueryPerformanceByDate",
          marketPlace,
          params,
          dates: { start, end, preStart, preEnd, group },
        },
      ],
      queryFn: async () => {
        const res = await apiClient.getV4SearchQueryPerformanceByDate({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(filters),
            search,
          },
        });
        return res;
      },
    });
  };
};
